import { Video, VideoOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { getIconSizeClass, type ButtonSize } from '../utils';

interface CameraButtonProps {
  isVideoOn: boolean;
  onToggle: () => void;
  size?: ButtonSize;
  className?: string;
}

export function CameraButton({
  isVideoOn,
  onToggle,
  size = 'default',
  className,
}: CameraButtonProps) {
  const { t } = useTranslation();
  const iconSize = getIconSizeClass(size);

  const turnOnLabel = t('videoSession.actions.turnOnCamera', 'Turn on camera');
  const turnOffLabel = t('videoSession.actions.turnOffCamera', 'Turn off camera');
  const label = isVideoOn ? turnOffLabel : turnOnLabel;

  return (
    <Button
      variant={isVideoOn ? 'outline' : 'destructive'}
      size={size === 'sm' ? 'icon-sm' : size === 'lg' ? 'icon-lg' : 'icon'}
      onClick={onToggle}
      className={cn('min-h-[44px] min-w-[44px]', className)}
      title={label}
      aria-label={label}
      aria-pressed={!isVideoOn}
    >
      {isVideoOn ? (
        <Video className={iconSize} aria-hidden="true" />
      ) : (
        <VideoOff className={iconSize} aria-hidden="true" />
      )}
    </Button>
  );
}
